export default {
  common: {
    noData: "Нет данных",
    noSearchData: "Нет результатов поиска",
    resend: "Отправить повторно",
    confirm: "Подтвердить",
    cancel: "Отменить",
    sort: "Сортировать",
    createdAt: "Время создания",
    updatedAt: "Время изменения",
    name: "Имя",
    nickName: "Ник",
    size: "Размер",
    type: "Тип",
    source: "Источник",
    endTime: "Дата окончания срока действия",
    handle: "В работе",
    fileList: "Список файлов",
    model: "Модель",
    customerService: "Служба поддержки",
    send: "Отправить",
    save: "Сохранить",
    modify: "Изменить",
    phone: "Телефон",
    email: "E-mail",
    code: "Проверочный код",
    wechat: "Wechat",
    image: "Картинки",
    audio: "Аудио",
    folder: "Папка",
    note: "Заметки",
    prompt: "Подсказка",
    copy: "Копировать",
    sms: "SMS",
    password: "Пароль",
    oldVersion: "Старый",
    newVersion: "Новый",
    upload: "Загрузить",
    downloading: "скачивание...",
    uploading: "Загрузка...",
    check: "查询",
  },

  router: {},

  tooltip: {},

  placeholder: {
    phone: "Введите номер телефона",
    email: "Введите E Mail",
    code: "Введите проверочный код",
    name: "Введите имя",
    website: "Пожалуйста, введите URL",
    img: "Выберите картинку",
    search: "Введите данные для поиска",
    content: "Введите ваши данные",
  },

  alert: {},

  elMsg: {
    phoneEmpty: "Поле телефона не может быть пустым или содержать пробелы",
    areaEmpty: "Поле необходимо заполнить",
    emailEmpty:
      "Поле электронной почты не может быть пустым или содержать пробелы",
    codeEmpty:
      "Поле проверочного кода не может быть пустым или содержать пробелы",
    contentEmpty: "Отправка пустого сообщения невозможна",
    nameEmpty: "Имя не может быть пустым",
    nameSame: "В данной папке уже есть блокнот с таким именем",
    emailError: "Адрес электронной почты имеет некорректный формат",
    max80: "Не более 80 символов",
    delSuccess: "Удаление завершено",
    delFailure: "Не удалось удалить",
    copySuccess: "Копировать успешно",
    copyFailure: "Не удалось скопировать",
    cancelSuccess: "Отмена совершена",
    favoriteSuccess: "Сборка завершена",
    restoreSuccess: "Восстановление завершено",
    pushSuccess: "Отправлено через Push-сервис",
    createSuccess: "Создание завершено",
    moveSuccess: "Перемещение завершено",
    unbindSuccess: "Отвязка произведена",
    modifySuccess: "Изменение произведено",
    bindSuccess: "Связывание успешно",
    checkSuccess: "Успешный поиск",
    getSuccess: "Получено успешно",
    sendSuccess: "Успешно отправлено",
    selectFile: "Отметьте файлы",
    tips1:
      "Объема облачного хранилища недостаточно. Освободите хранилище и попробуйте снова.",
    tips2: "Размер файла не должен превышать 200 МБ",
    tips3: "Выберите файл для работы",
    tips4: "Загрузите файлы картинов в JPG, JPEG или PNG форматах.",
    tips5: "Введите правильный URL ",
    tips6: "Выберите папку",
    tips7: "Размер картинки не может превышать 3 МБ",
    tips8: "Выберите картинки, которые хотите загрузить",
    tips9: "Проверочный код может содержать только цифры",
    tips10:
      "Данный телефон уже привязан к другому пользователю. Повторная привязка невозможна.",
    tips11: "Номер телефона привязан успешно.",
    tips12:
      "Данная электронная почта уже привязана к другому пользователю. Повторная привязка невозможна.",
    tips13: "Электронная почта привязана успешно",
    tips14:
      "Срок действия логина этой учетной записи истек. Пожалуйста, войдите в систему еще раз.",
    tips15: "Размер файла превышает%{size}",
    tips16:
      "Устройство не привязано. Пожалуйста, осуществите привязку непосредственно с устройства.",
    tips17:
      "У этой учетной записи уже есть основная учетная запись, и ее нельзя связать",
    tips18: "Скопируйте код в буфер обмена",
    tips19: "Отметьте аудио, которое необходимо скачать",
    tips20: "如该号码收不到验证码，请与商家联系确定手机号",
  },

  login: {
    logout: "Выйти ",
    login: "Войти",
    phoneLogin: "Войти с помощью телефона",
    emailLogin: "Войти с помощью E mail",
    scanLogin: "Сканировать код для входа",
    scanTips1: "Открыть приложение BOOX Assistant",
    scanTips2: "Открыть「Сканировать」вверху учетной записи",
    scanTips3: "QR-код истек. Пожалуйста, просканируйте еще раз.",
    getCode: "Получить проверочный код",
    agree: "Согласен",
    privacy: "Политика конфиденциальности",
    agreement: "Пользовательское Соглашение",
    autoLogin: "Запомнить меня",
  },
};
